import React from "react"
import { graphql } from "gatsby"
import { Typography, withStyles, Avatar } from "@material-ui/core"
import Link from "@material-ui/core/Link"
import { Layout } from "../components/layout"
import { MyMarkdown } from "../components/MyMarkdown"

export const pageQuery = graphql`
    query($slug: String!) {
        googleSheetWorkshopsRow(fields: {slug: {eq: $slug}}) {
            author,
            title,
            subtitle,
            text,
            about,
            webpage,
            childrenDropboxNode {
                localFile {
                    childImageSharp {
                        fixed(width: 256, height: 256) {
                            src
                            srcSet
                        }
                    }
                }
            }
        }
    }
`

const styles = (theme) => ({
    spaceTop: {
        marginTop: theme.spacing(4),
    },
    rightLeft: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
    },
    avatar: {
        height: theme.spacing(16),
        width: theme.spacing(16),
    },
    text: {
        marginTop: theme.spacing(4),
    },
})

const getSrcSet = (speaker) => {
    const cdn = speaker.childrenDropboxNode[0]
    if (!cdn) return null
    return cdn.localFile.childImageSharp.fixed.src
}

const workshopTemplate = ({ data, classes }) => {
    const speaker = data.googleSheetWorkshopsRow

    return (
        <Layout title={speaker.title}>

            <div className={classes.rightLeft}>
                <div>
                    <Typography variant='h2'>{speaker.title}</Typography>
                    {speaker.subtitle && <Typography variant={"h5"}>{speaker.subtitle}</Typography>}
                    <Typography variant='h4' color={"textSecondary"}>{speaker.author}</Typography>
                </div>

                <Avatar className={classes.avatar} src={getSrcSet(speaker)}/>
            </div>

            <div className={classes.text}>
                <MyMarkdown children={speaker.text}/>
            </div>

            <Typography variant='h4' color={"textSecondary"} className={classes.spaceTop}>{speaker.author}</Typography>
            <Typography>{speaker.about}</Typography>
            {speaker.webpage && <Link href={speaker.webpage}>{speaker.webpage}</Link>}
        </Layout>
    )
}

export default withStyles(styles)(workshopTemplate)